import { type ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { useMatch } from 'react-router'
import { type CallCenterViewModel } from '@/features/call-center/CallCenterViewModel'
import { AddClientDialogContainer } from '@/features/call-center/AddClientDialog/AddClientDialogContainer'
import { CreateJobConfirmationDialogContainer } from '@/features/call-center/CreateJobConfirmationDialog/CreateJobConfirmationDialogContainer'
import { CallCenter } from '@/features/call-center/CallCenter'

interface CallCenterFrameContainerProps {
  vm: CallCenterViewModel
  children: ReactNode
}

export const CallCenterFrameContainer = observer(
  function CallCenterFrameContainer({
    vm,
    children,
  }: CallCenterFrameContainerProps) {
    const isOnCheckoutPage = Boolean(
      useMatch({ path: '/call-center/:jobId/checkout', end: false }),
    )

    return (
      <CallCenter
        breadcrumbItems={vm
          .getBreadcrumbItems(isOnCheckoutPage)
          .map((item) => ({
            ...item,
            onPress: () => vm.setActiveSection(item.id),
          }))}
        dialogs={
          <>
            <CreateJobConfirmationDialogContainer
              vm={vm.jobVm.confirmationDialog}
            />
            <AddClientDialogContainer vm={vm.addClientDialogVm} />
          </>
        }
      >
        {children}
      </CallCenter>
    )
  },
)
